// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3e-YA","toggle":"styles_toggle__31REQ","preview":"styles_preview__1YQif"};